import React from 'react'

// Mock CameraView component — on web the card scanner uses file upload,
// so the camera preview is never rendered.  Providing a lightweight stub
// avoids pulling in expo-camera's web bundle which creates a Web Worker
// that loads jsQR from a CDN via importScripts, failing on unreliable
// networks (Sentry JAVASCRIPT-REACT-1).
export const CameraView = React.forwardRef<any, any>(({ style, children, ...rest }, ref) => {
  return (
    <div
      ref={ref as any}
      style={{
        ...style,
        backgroundColor: 'black',
        color: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {children}
    </div>
  )
})

CameraView.displayName = 'CameraView'

// Mock CameraType
export type CameraType = 'front' | 'back'

// Mock useCameraPermissions — returns "not granted" on web so the
// native camera path is never entered.
export function useCameraPermissions(): [
  { granted: boolean; canAskAgain: boolean; status: string } | null,
  () => Promise<{ granted: boolean; canAskAgain: boolean; status: string }>,
] {
  const permission = { granted: false, canAskAgain: false, status: 'undetermined' }
  const requestPermission = async () => permission
  return [permission, requestPermission]
}

// Re-export anything else that might be imported as a no-op
export const BarCodeScanner = CameraView
export default { CameraView, useCameraPermissions, BarCodeScanner }
